<template>
  <v-app>
    <v-app-bar app flat>
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="light-blue lighten-3">
      <v-container fill-height fluid class="account-bg">
        <div class="login-bg"></div>
        <v-row align="center">
          <v-col md="6" offset-md="3">
            <ResetPasswordComponent />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import ResetPasswordComponent from "@/components/user/ResetPasswordComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";

export default {
  name: "ResetPassword",
  components: {
    FullHeaderComponent,
    ResetPasswordComponent,
    CopyrightComponent
  }
};
</script>

<style scoped>
.account-bg {
  background-image: url("~@/assets/images/bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
